module.exports = __webpack_public_path__ + "img/bg_pno_default.6461fc90.jpg";